import { translate } from 'react-i18next';

// Styles
import { AppointmentsPageHeader } from '../styles';

// Components
import FiltersSection from './FiltersSection/FiltersSection';
import DateFilter from './DateFilter/DateFilter';

export default translate()(props => {
  const { i18n, startDate, onDateChange } = props;

  return (
    <AppointmentsPageHeader>
      <div className="caption">
        <p className="name">{i18n.t('planning')}</p>
      </div>

      <div className="filter">
        <FiltersSection />
        <DateFilter startDate={startDate} onDateChange={onDateChange} />
      </div>
    </AppointmentsPageHeader>
  );
});
